if (!customElements.get('ff-ingredients')) {
  customElements.define(
    'ff-ingredients',
    class FfIngredients extends HTMLElement {
      constructor() {
        super();
        this.tabs = this.querySelectorAll('.ff-ingredients__tab');
        this.cards = this.querySelectorAll('.ff-ingredients__card');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab));
        });
      }

      selectTab(selectedTab) {
        const target = selectedTab.dataset.tab;

        this.tabs.forEach((tab) => {
          const isActive = tab === selectedTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive);
        });

        this.cards.forEach((card) => {
          card.classList.toggle('is-visible', card.dataset.tab === target);
        });
      }
    }
  );
}
